import { render, staticRenderFns } from "./TheCrew.vue?vue&type=template&id=60937fb6&scoped=true&"
import script from "./TheCrew.vue?vue&type=script&lang=js&"
export * from "./TheCrew.vue?vue&type=script&lang=js&"
import style0 from "./TheCrew.vue?vue&type=style&index=0&id=60937fb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60937fb6",
  null
  
)

export default component.exports